import React, {useEffect, useState} from 'react'
import Header from "../../layout/header";
import ReactPaginate from "react-paginate";
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import Moment from "moment";
import {toast} from "react-toastify";
import NotFoundData from "../../../Images/no-data-found.webp";

const AttendanceRegularizationList = ({
                                          match,
                                          history,
                                          regularizationList,
                                          attendanceList=[]
                                      }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [userId, setUserId] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await regularizationList()
            setIsLoading(false)
        })()
        setUserId(window.localStorage.user_id)
    }, [])

    const onPageChange = async (val) => {
        setIsLoading(true)
        await regularizationList(val?.selected + 1)
        setIsLoading(false)
    };
    return (
        <>
            <Loader isLoading={isLoading}/>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Activity List'}
                            history={history}
                        />
                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="row mt-10">
                                    {
                                        <>
                                            {attendanceList && attendanceList?.data !== undefined && attendanceList?.data.length > 0 && attendanceList?.data.map((val, i) => {
                                                return (
                                                    <>
                                                        <div className="col-md-4 col-sm-6">
                                                            <div className="card-big-shadow card-padding">
                                                                <div className="card card-just-text"
                                                                     data-background="color"
                                                                     data-color=""
                                                                     data-radius="none">
                                                                    <div className="content">
                                                                        <h6 className="category">
                                                                            {parseInt(val?.status) === 1 ?
                                                                                <div className="header-ui-item-opp"
                                                                                     style={{backgroundColor: "#bea925"}}>
                                                                                    {val?.in_attendance_regularization === 1 ?
                                                                                        "Regularisation Pending" :
                                                                                        "Pending"
                                                                                    }
                                                                                </div> : parseInt(val?.status) === 2 ?
                                                                                    <div className="header-ui-item-opp">
                                                                                        Approved
                                                                                    </div> :
                                                                                        <div
                                                                                            className="header-ui-item-opp"
                                                                                            style={{backgroundColor: "#88130a"}}>
                                                                                            Rejected
                                                                                        </div>
                                                                            }

                                                                            <div className="row">
                                                                                <div className="col-10" style={{
                                                                                    color: "#000",
                                                                                    fontSize: "20px",
                                                                                    textAlign: "left",
                                                                                    paddingLeft: "20px"
                                                                                }}>
                                                                                    <span
                                                                                        className="">{val?.client_name}

                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="row list-view">
                                                                                {val?.activity_name !== undefined &&
                                                                                    <div className="mb-flex">
                                                                                        <div
                                                                                            className="col-md-6 col-sm-6 no-wrap">
                                                                                            <i className="fas fa-comment"></i>&nbsp;&nbsp;Activity Name
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-md-6 col-sm-6">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.activity_name}>
                                                                                        {val?.activity_name}
                                                                                    </span>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                                <div className="mb-flex">
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6 no-wrap">
                                                                                        <i className="fa fa-user"
                                                                                           aria-hidden="true"></i>
                                                                                        &nbsp;&nbsp;Request By
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6">{val?.user_name}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="mb-flex">
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6 no-wrap">
                                                                                        <i className="bi bi-building"></i>&nbsp;&nbsp;Activity
                                                                                        Date
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6">{Moment(val?.activity_date).format('DD-MM-YYYY HH:mm:ss')}
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <hr/>
                                                                            <div className="row list-view-links">
                                                                                <ul>
                                                                                    <li>
                                                                                        <a
                                                                                            href={`/view-activity/${val?.id}`}
                                                                                        ><i
                                                                                            className="bi bi-check2-circle"
                                                                                            style={{fontSize: "16px"}}></i>
                                                                                            &nbsp;&nbsp;View
                                                                                        </a>
                                                                                    </li>
                                                                                    {parseInt(val?.status) === 1 &&

                                                                                        <li>
                                                                                            <a
                                                                                                href={`/attendance-regularization-approval/${val?.id}`}><i
                                                                                                className="bi bi-check2-circle"
                                                                                                style={{fontSize: "16px"}}></i>
                                                                                                &nbsp;&nbsp;Action
                                                                                            </a>
                                                                                        </li>
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        </h6>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                            {attendanceList && attendanceList?.data !== undefined && attendanceList?.data.length > 0 &&
                                                <div className="panel-pagination-col panel-table-pagination">
                                                    <ReactPaginate
                                                        previousLabel={'<'}
                                                        nextLabel={'>'}
                                                        breakLabel={'...'}
                                                        breakClassName={'break-me'}
                                                        pageCount={(attendanceList?.total / attendanceList?.per_page)}
                                                        forcePage={attendanceList?.current_page - 1}
                                                        pageRangeDisplayed={4}
                                                        onPageChange={onPageChange}
                                                        activeClassName={'active'}
                                                    />
                                                </div>
                                            }
                                            {attendanceList && attendanceList?.data !== undefined && attendanceList?.data.length === 0 &&
                                                <>
                                                    <img src={NotFoundData} className="not-found-data" alt={""}/>
                                                    <div className="text-center" style={{"width": "100%"}}>
                                                        Data Not Found
                                                    </div>
                                                </>
                                            }
                                        </>
                                    }
                                    {/*PAGINATION END*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* section ends */}
        </>
    )
}

export default AttendanceRegularizationList